/* eslint-disable react/prop-types */
import { useState } from "react";
import { Controller } from "react-hook-form";
import {
    Button,
    Popover,
    Box,
    
    IconButton,
    Divider,
    List,
    ListItem,
    
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CloseIcon from "@mui/icons-material/Close";

const RHFFileUpload = ({ formData, control }) => {
    const [selectedFiles, setSelectedFiles] = useState([]);

    
    const [anchorEl, setAnchorEl] = useState(null);

    const rules = formData?.Validations?.reduce((acc, validation) => {
        if (validation.ValidationType === "Required") {
            acc.required = validation.ValidationMessage || "This field is required";
        }
        return acc;
    }, {});

    const handleFileChange = (e, field) => {
        const files = Array.from(e.target.files);
        const updatedFiles = [...(field.value || []), ...files]; // Combine new and existing files
        setSelectedFiles(updatedFiles);
        field.onChange(updatedFiles); // Update form state
    };

    const handleRemoveFile = (index, field) => {
        const updatedFiles = selectedFiles.filter((_, i) => i !== index);
        setSelectedFiles(updatedFiles);
        field.onChange(updatedFiles); // Update form state

        // Close the popover if no files are left
        if (updatedFiles.length === 0) {
            setAnchorEl(null);
        }
    };


    const handleFileCountClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClosePopover = () => {
        setAnchorEl(null);
    };

    return (
        <Controller
            name={formData.ValueExpr}
            control={control}
            rules={rules}
            render={({ field, fieldState: { error } }) => {
                // Sync selectedFiles with field.value
                if ((field.value || []).length !== selectedFiles.length) {
                    setSelectedFiles(field.value || []); // Handle reset or clearing of field.value
                }

                return (
                    <div>
                        <Button
                            component="label"
                            variant="contained"
                            startIcon={<CloudUploadIcon />}
                            style={{
                                marginRight: "8px",
                                padding: "3px 8px",
                                fontSize: "13px",
                            }}
                        >

                            {formData?.LabelName || formData?.DisplayExpr}{rules?.required && (
                                <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                            )}
                            <input
                                type="file"
                                style={{ display: "none" }}
                                multiple
                                onChange={(e) => handleFileChange(e, field)}
                            />
                        </Button>

                        {selectedFiles.length > 0 && (
                            <Button
                                variant="text"
                                size="small"
                                onClick={handleFileCountClick}
                            >
                                {selectedFiles.length === 1
                                    ? "1 file selected"
                                    : `${selectedFiles.length} files selected`}
                            </Button>
                        )}

                        {error && (
                            <p
                                style={{
                                    color: "red",
                                    fontSize: "10px",
                                    marginTop: "0.5em",
                                }}
                            >
                                {error.message}
                            </p>
                        )}

                        {
                            selectedFiles && selectedFiles.length > 0 && 
                        <Popover
                            open={Boolean(anchorEl)}
                            anchorEl={anchorEl}
                            onClose={handleClosePopover}
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "left",
                            }}
                            sx={{
                                mt: "-15px",
                            }}
                        >
                            <Box
                                sx={{
                                    width: { xs: "90vw", sm: 350 },
                                    maxWidth: 600,
                                }}
                            >
                                <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                padding: '4px 14px',
                                                backgroundColor: '#3B3C78',
                                                color: 'white',
                                                height: '30px',
                                            }}
                                >
                                    <span style={{fontSize: '14px'}}>Files</span>
                                    <IconButton
                                        edge="end"
                                        aria-label="close"
                                        onClick={handleClosePopover}
                                        sx={{ color: 'white', padding: '4px' }}
                                    >
                                                <CloseIcon fontSize="small" />
                                    </IconButton>
                                </Box>

                                <Divider />
                                    <Box
                                        sx={{
                                            maxHeight: { xs: 150, sm: 200 },
                                            overflowY: "auto",
                                        }}
                                    >
                                        <List>
                                            {selectedFiles.map((file, index) => (
                                                <ListItem key={index} sx={{ paddingX: '8px' }}> { /* NOSONAR: Index as key is acceptable due to non-reordering static list */ }
                                                    <span style={{ fontSize: '13px' }}>{file?.isDummy ? file?.name?.replace(/^\d+_/, '') : file?.name}</span>
                                                    <IconButton
                                                        edge="end"
                                                        aria-label="delete"
                                                        onClick={() => handleRemoveFile(index, field)}
                                                    >
                                                        <CloseIcon sx={{ width: '20px', height: '20px' }} />
                                                    </IconButton>
                                                </ListItem>
                                            ))}
                                        </List>
                                    </Box>
                                
                                
                            </Box>
                            </Popover>
                        }
                    </div>
                );
            }}
        />
    );
};

export default RHFFileUpload;
